import React from 'react';
import get from 'lodash/get';
import {constants} from '@neosvoc/nv-platform-core-common';
import String1Type from './types/String1Type';
import Text1Type from './types/Text1Type';
import Battery1Type from './types/Battery1Type';
import Battery2Type from './types/Battery2Type';
import Date1Type from './types/Date1Type';
import MultipleChoice1Type from './types/MultipleChoice1Type';
import MultipleChoice2Type from './types/MultipleChoice2Type';
import Number1Type from './types/Number1Type';
import Number2Type from './types/Number2Type';
import SingleChoice1Type from './types/SingleChoice1Type';
import SingleChoice2Type from './types/SingleChoice2Type';
import SingleChoice3Type from './types/SingleChoice3Type';
import SingleChoice4Type from './types/SingleChoice4Type';
import SingleChoice1ExtType from './types/SingleChoice1ExtType';
import MultipleNumber1Type from './types/MultipleNumber1Type';
import MultipleNumber2Type from './types/MultipleNumber2Type';
import MultipleNumber3Type from './types/MultipleNumber3Type';
import Rank1Type from './types/Rank1Type';
import Image1Type from './types/Image1Type';
import GeneratorClassifierType from './types/GeneratorClassifierType';
import Geo1Type from './types/Geo1Type';
import GeneratorClassifier2Type from './types/GeneratorClassifier2Type';

const Editor = ({form, name, currPage}) => {
    const pagesBeforeCurrent = (get(form.values, 'editor.pages') || []).slice(0, currPage);
    const items = get(form.values, name) || [];
    return (
        <>
            {items.map((item, index) => {
                const previousPages = [...pagesBeforeCurrent, {items: items.slice(0, index)}];
                switch (item.type) {
                    case constants.EDITOR_TEMPLATES.STRING_1:
                        return <String1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.TEXT_1:
                        return <Text1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1:
                        return <SingleChoice1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2:
                        return <SingleChoice2Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3:
                        return <SingleChoice3Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4:
                        return <SingleChoice4Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.NUMBER_1:
                        return <Number1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.NUMBER_2:
                        return <Number2Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1:
                        return <MultipleNumber1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3:
                        return <MultipleNumber3Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2:
                        return <MultipleNumber2Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1:
                        return <MultipleChoice1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2:
                        return <MultipleChoice2Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.DATE_1:
                        return <Date1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.BATTERY_1:
                        return <Battery1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.BATTERY_2:
                        return <Battery2Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT:
                        return <SingleChoice1ExtType key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.IMAGE_1:
                        return <Image1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.GEO_1:
                        return <Geo1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER:
                        return <GeneratorClassifierType key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.RANK_1:
                        return <Rank1Type key={index} name={`${name}.${index}`} form={form} previousPages={previousPages} />;
                    case constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2:
                        return <GeneratorClassifier2Type key={index} name={`${name}.${index}`} form={form} currPage={currPage} previousPages={previousPages} />;
                }
            })}
        </>
    );
};

export default Editor;
